
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/opendock",
      function () {
        return require("private-next-pages/en/opendock/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/opendock"])
      });
    }
  